import React, { useState } from 'react'
import { classNames } from '@/shared/lib/utils/classNames'
import { ContactForm } from '../../widgets/ContactForm/ContactForm'
import { Benefits } from '../../widgets/Benefits/Benefits'
import { Instruction } from '../../widgets/Instruction/Instruction'
import StartImage from '@/shared/assets/desktop/startImg.webp'
import coins from '@/shared/assets/desktop/coins.png'
import { ReactComponent as YellowGlow } from '@/shared/assets/desktop/yellowGlow.svg'
import cls from './DistributorPage.module.scss'
import { EasyAdministration } from '../../widgets/EasyAdministration/EasyAdministration'
import { useTranslation } from 'react-i18next'

const BecomeButton = ({ setOpen, className, position }) => {
    const { t } = useTranslation()
    return (
        <button
            onClick={() => {
                setOpen(true)
            }}
            className={classNames(cls.becomeDistrButton, [className])}
        >
            <h1>{t('navigation.becomeD')}</h1>
            <span>{t('navigation.distributor')}</span>
        </button>
    )
}

export const DistributorPage = () => {
    const [open, setOpen] = useState(false)
    const { t } = useTranslation()
    return (
        <div
            id="distributor"
            className={cls.wrapper}
        >
            <div className={cls.startBlock}>
                <div className={cls.startBlockText}>
                    <h2>
                        <span>{t('title.start')}</span> {t('title.part1')}
                    </h2>
                    <h1>{t('title.part2')}</h1>
                    <p>{t('title.part3')} </p>
                </div>
                <BecomeButton
                    position={'home'}
                    setOpen={setOpen}
                    className={cls.startBecomeButton}
                />
                <img
                    src={StartImage}
                    className={cls.StartImage}
                    alt="startimg"
                />
                <div className={cls.shadow} />
                <div className={cls.bottomShadow} />
            </div>

            <Benefits variant="distributor" />
            <EasyAdministration />
            <Instruction variant="distributor" />

            <div className={cls.becomeButtonContainer}>
                <BecomeButton
                    position={'footer'}
                    setOpen={setOpen}
                    className={cls.becomeButtonEnd}
                />
            </div>

            <div className={cls.decoration}>
                <YellowGlow className={cls.glow} />
                <img
                    src={coins}
                    className={cls.coins}
                    alt="coins"
                />
            </div>

            <ContactForm
                open={open}
                setOpen={setOpen}
            />
        </div>
    )
}
